import styled from "styled-components";

const Header = styled.div`
  margin-bottom: 48px;
  position: relative;

  @media (max-width: 425px) {
    /* left: 23px; */
  }

  @media (min-width: 426px) {
    /* left: 33px; */
  }

  @media (min-width: 769px) {
    /* left: 47px; */
  }
`;

export default Header